module.exports = __webpack_public_path__ + "static/media/Driveline_CV_Shaft_Black.c548a277.webp";